import { RequestStatusWithData } from '@customTypes/api/api.types';

export enum REQUESTS_PATH {
    UPLOAD_INBOUND_FILE = '/Replenishments/GoodPartsUpload/UploadFile',
    UPLOAD_DEFECTIVE_INBOUND_FILE = '/ReturnParts/DefectiveToChoiceUpload/UploadFile',
    UPLOAD_OUTBOUND_FILE = '/CustomerDelivery/GoodPartsUpload/UploadFile',
    UPLOAD_DEFECTIVE_OUTBOUND_FILE = '/ReturnParts/DefectiveFromChoiceUpload/UploadFile',
    UPLOAD_TRANSFERS_FILE = '/WarehouseTransfers/GoodPartsUpload/UploadFile',
    UPLOAD_DEFECTIVE_TRANSFERS_FILE = '/WarehouseTransfers/DefectivePartsUpload/UploadFile',
    ADD_DOCUMENT = '/TrackOrders/AddTicketDocument',
    UPDATE_DOCUMENT = '/TrackOrders/UpdateTicketDocument',
    ADD_MIR_DOCUMENT = '/MaterialInReview/AddDocument'
}

export type UploadFileSuccessResponse = RequestStatusWithData<{
    fileId: string;
}>;

export interface UploadFileDTO {
    file: FormData;
}

export interface UploadFileError {
    error: {
        status: number;
        data: string;
    };
}

export type UploadFileResponse = UploadFileSuccessResponse | UploadFileError;

export interface AddDocumentData {
    ticketDocumentHistoryId: number;
}
export type AddDocumentResponse = RequestStatusWithData<AddDocumentData>;
